export default __webpack_public_path__ + "static/media/brown-sexy.ac00f487.gif";